// extracted by mini-css-extract-plugin
export default {"title":"LinedDecorTitleWhite_title__AlORs"};